var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWithoutWords(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.823,
    height: 44,
    viewBox: "0 0 54.823 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#583c77;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-904.864 -409.958)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.9,39.3C3.448,35.513.491,29.965.133,26.617c-.836-5.4,2.533-10.153,2.533-10.153A50.317,50.317,0,0,1,2.21,7.007C2.476,2.061,3.855.9,4.927.312S8.48-.147,12.269,1.757a72.152,72.152,0,0,1,7.267,4.28,42.963,42.963,0,0,1,7.875-.807,42.963,42.963,0,0,1,7.875.807,72.152,72.152,0,0,1,7.267-4.28C46.343-.147,48.824-.281,49.9.312s2.451,1.749,2.717,6.7a50.317,50.317,0,0,1-.457,9.457s3.369,4.753,2.533,10.153c-.358,3.348-3.315,8.9-9.771,12.686A32.252,32.252,0,0,1,27.412,44,32.252,32.252,0,0,1,9.9,39.3Z",
    transform: "translate(904.864 409.958)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910.793 428.918)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.754 11.654)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.855.326H3.08A.171.171,0,0,1,3.251.5L2.568,2.838a.685.685,0,0,1-.685.685H.685A.685.685,0,0,1,0,2.838L.684.5A.171.171,0,0,1,.855.326Z",
    transform: "translate(0.796 2.469)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-2.026-.294l6.47-.061a.171.171,0,0,1,.171.171L4.162,1.2a.171.171,0,0,1-.171.171l-6.47.061a.171.171,0,0,1-.171-.171L-2.2-.122A.171.171,0,0,1-2.026-.294Z",
    transform: "translate(2.65 0.354)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.013)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-2.026,0H.2A.171.171,0,0,1,.371.171L-.083,1.554a.171.171,0,0,1-.171.171H-2.479a.171.171,0,0,1-.171-.171L-2.2.171A.171.171,0,0,1-2.026,0Z",
    transform: "translate(8.188)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-2.026,0H.2A.171.171,0,0,1,.371.171L-.083,1.554a.171.171,0,0,1-.171.171H-2.479a.171.171,0,0,1-.171-.171L-2.2.171A.171.171,0,0,1-2.026,0Z",
    transform: "translate(7.332 2.568)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.989.354H4.214a.171.171,0,0,1,.171.171L2.568,6.114a.171.171,0,0,1-.171.171H.685A.685.685,0,0,1,0,5.6L1.817.525A.171.171,0,0,1,1.989.354Z",
    transform: "translate(0 -0.294)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.506 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-6.282,0h3.1a.171.171,0,0,1,.171.171l-.454,1.383a.171.171,0,0,1-.171.171l-.073.783-1.134.96a1.445,1.445,0,0,1,.364,1.018,10.206,10.206,0,0,1-.375,1.3c-.029.086-.029.084-.081.127a.242.242,0,0,1-.129.046H-6.927a.229.229,0,0,1-.147-.029.338.338,0,0,1-.1-.14l-.559-1.272a.536.536,0,0,1-.057-.19.534.534,0,0,1,.031-.2l.439-1.336a.222.222,0,0,1,.057-.118.208.208,0,0,1,.123-.036h.551a.233.233,0,0,0,.123-.026c.033-.029.023-.1.023-.1l.065-.566a.215.215,0,0,0,0-.123.136.136,0,0,0-.089-.057l-.274-.036a.171.171,0,0,1-.171-.171L-6.453.171A.171.171,0,0,1-6.282,0Z",
    transform: "translate(12.273)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.989.354H4.214a.171.171,0,0,1,.171.171L2.568,6.114a.171.171,0,0,1-.171.171H.685A.685.685,0,0,1,0,5.6L1.817.525A.171.171,0,0,1,1.989.354Z",
    transform: "translate(0 -0.28)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.217 0.074)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.989.354H4.214a.171.171,0,0,1,.171.171L2.568,6.114a.171.171,0,0,1-.171.171H.685A.685.685,0,0,1,0,5.6L1.817.525A.171.171,0,0,1,1.989.354Z",
    transform: "translate(0 -0.354)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-6.721.354H-8.946a.171.171,0,0,0-.171.171L-11,6.114a.171.171,0,0,0,.171.171h1.712a.878.878,0,0,0,.785-.693L-6.549.525A.171.171,0,0,0-6.721.354Z",
    transform: "translate(14.937 -0.354)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.578 0.074)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.989.354H4.214a.171.171,0,0,1,.171.171L2.568,6.114a.171.171,0,0,1-.171.171H.685A.685.685,0,0,1,0,5.6L1.817.525A.171.171,0,0,1,1.989.354Z",
    transform: "translate(0 -0.354)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-6.721.354H-8.946a.171.171,0,0,0-.171.171L-11,6.114a.171.171,0,0,0,.171.171h1.712a.878.878,0,0,0,.785-.693L-6.549.525A.171.171,0,0,0-6.721.354Z",
    transform: "translate(14.937 -0.354)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.713 11.714)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.989.354H4.214a.171.171,0,0,1,.171.171L2.568,6.114a.171.171,0,0,1-.171.171H.685A.685.685,0,0,1,0,5.6L1.817.525A.171.171,0,0,1,1.989.354Z",
    transform: "translate(0 -0.354)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-6.721.354H-8.946a.171.171,0,0,0-.171.171L-11,6.114a.171.171,0,0,0,.171.171h1.712a.878.878,0,0,0,.785-.693L-6.549.525A.171.171,0,0,0-6.721.354Z",
    transform: "translate(14.937 -0.354)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWithoutWords);
export default __webpack_public_path__ + "static/media/logoWithoutWords.428a7960.svg";
export { ForwardRef as ReactComponent };